import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';

const ColorPreview = styled(Box)<{ color?: string }>(({ color }) => ({
  width: 40,
  height: 32,
  backgroundColor: color || '#ffffff',
  border: '2px solid #e0e0e0',
  borderRadius: 6,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '10px',
  fontWeight: 'bold',
  color: color && (color === '#ffffff' || color === '#f5f5f5') ? '#000' : '#fff',
  textShadow: '1px 1px 1px rgba(0,0,0,0.3)',
  flexShrink: 0
}));

interface ColorSelectorProps {
  label: string;
  value: string;
  onChange: (color: string) => void;
  name: string;
  helperText?: string;
}

const ColorSelector: React.FC<ColorSelectorProps> = ({
  label,
  value,
  onChange,
  name,
  helperText
}) => {
  const [customColor, setCustomColor] = useState(value);

  const handleCustomColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = event.target.value;
    setCustomColor(newColor);
    onChange(newColor);
  };

  return (
    <Box>
      <Typography variant="caption" sx={{ mb: 1, display: 'block', fontWeight: 500, color: 'text.secondary' }}>
        {label}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ColorPreview color={customColor}>
          {customColor}
        </ColorPreview>
        <TextField
          type="color"
          value={customColor}
          onChange={handleCustomColorChange}
          size="small"
          sx={{
            flexGrow: 1,
            '& input': {
              height: 32,
              cursor: 'pointer'
            },
            '& .MuiOutlinedInput-root': {
              height: 32
            }
          }}
        />
      </Box>
    </Box>
  );
};

export default ColorSelector;
